// import React, { useEffect, useState } from 'react'
// import { useParams, useNavigate } from 'react-router-dom'
// import Header from '../Components/Header'
// import Footer from '../Components/Footer'
// import Banner from '../Components/CourseDetailPage/Banner'
// import axios from 'axios'
// import Swal from 'sweetalert2'
// // import MaterialSection from "../Components/CourseDetailPage/MaterialsSection";
// import Reviews from '../Components/CourseDetailPage/Reviews'
// import StudentsSection from '../Components/CourseDetailPage/StudentsSection'
// import AddMaterial from '../Components/CourseDetailPage/AddMaterial'
// import EditCourseModal from '../Components/CourseDetailPage/EditCourseModal'
// import { Button } from 'react-bootstrap'
// import CourseSection from '../Components/CourseDetailPage/CourseViewer'
// import { Trash } from 'lucide-react'
// import Learnyou from '../Components/CourseDetailPage/Learnyou'
// export default function CourseDetails() {
//   const { id } = useParams()
//   const [course, setCourse] = useState({ parts: [] })
//   const navigate = useNavigate()
//   const [materials, setMaterials] = useState([])
//   const [reviews, setReviews] = useState([])
//   const [students, setStudents] = useState([])

//   const [isInstructor, setInstructor] = useState(false)
//   const [isEnrolled, setEnrolled] = useState(false)

//   const [showModal, setShowModal] = useState(false)
//   const [showEditModal, setEditModal] = useState(false)

//   const [isEnrolledClicked, setEnrolledClicked] = useState(false)
//   const [loading, setLoading] = useState(false)

//   const handleShow = () => setShowModal(true)
//   const handleClose = () => setShowModal(false)
//   const handleEdit = () => setEditModal(true)
//   const handleEditClose = () => setEditModal(false)

//   const token = localStorage.getItem('jwttoken')
//   const url = 'https://kaasbackend.vetrinahealthcare.com/'

//   const getCourseDetails = () => {
//     setLoading(true) // Start loading
//     axios
//       .get(`${url}lms/courses/${id}/`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         setCourse(response.data)
//         setInstructor(response.data.display.is_instructor)
//         setEnrolled(response.data.display.is_enrolled)
//         setLoading(false) // Stop loading
//       })
//       .catch((error) => {
//         console.error('Error fetching course details:', error)
//         setLoading(false) // Stop loading
//       })
//   }

//   useEffect(() => {
//     getCourseDetails()
//   }, [])

//   const getMaterials = () => {
//     setLoading(true) // Start loading
//     axios
//       .get(`${url}lms/courses/${id}/materials/`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         setMaterials([...response.data.materials])
//         setLoading(false) // Stop loading
//       })
//       .catch((reason) => {
//         console.log(reason)
//         setLoading(false) // Stop loading
//       })
//   }

//   const getReviews = () => {
//     setLoading(true) // Start loading
//     axios
//       .get(`${url}lms/review/${id}/`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         setReviews([...response.data.reviews])
//         setLoading(false) // Stop loading
//       })
//       .catch((reason) => {
//         console.log(reason)
//         setLoading(false) // Stop loading
//       })
//   }

//   const getStudents = () => {
//     setLoading(true) // Start loading
//     axios
//       .get(`${url}lms/courses/${id}/students`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         const data = response.data.students
//         setStudents([...data])
//         setLoading(false) // Stop loading
//       })
//   }

//   useEffect(() => {
//     getCourseDetails()
//     getMaterials()
//     getReviews()
//     getStudents()
//   }, [showModal, showEditModal])

//   const enrollStudent = () => {
//     setLoading(true) // Start loading
//     if (isEnrolledClicked || isEnrolled) {
//       Swal.fire({
//         title: 'Already Enrolled',
//         text: "You're already enrolled in this course",
//         icon: 'warning',
//         timer: 1000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       })
//       return
//     }

//     axios
//       .post(
//         `${url}lms/enroll/${id}/`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//       .then((response) => {
//         console.log('Response:', response)
//         setEnrolled(true)
//         setEnrolledClicked(true)
//         setLoading(true) // Start loading
//         Swal.fire({
//           title: 'Success!',
//           text: 'Enrollment Successful',
//           icon: 'success',
//           timer: 1000,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         })
//       })
//       .catch((reason) => {
//         setLoading(true) // Start loading
//         console.error('Error:', reason)
//         Swal.fire({
//           title: 'Already Enrolled',
//           text: "You're already enrolled in this course",
//           icon: 'warning',
//           timer: 1000,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         })
//       })
//   }

//   return (
//     <div>
//       <Header />
//       <div
//         className='px-5 pt-4'
//         style={{
//           backgroundImage:
//             'linear-gradient(180.06deg, #E9F7FA 29.88%, #F8EEF5 58.49%)',
//         }}
//       >
//         <Banner
//           course={course}
//           isEnrolled={isEnrolled}
//           isInstructor={isInstructor}
//           trailer={course.trailer}
//           lessonCount={course.parts.length}
//           onEnroll={enrollStudent}
//         />
//         <Learnyou courseKeyPoints={course.course_key_points} />

//         {(isEnrolled || isInstructor) && <CourseSection />}
//         {isInstructor && <StudentsSection students={students} />}

//         <Reviews reviews={reviews} />
//         <AddMaterial
//           course_id={id}
//           show={showModal}
//           handleClose={() => setShowModal(false)}
//         />
//         <EditCourseModal
//           course_id={id}
//           show={showEditModal}
//           handleClose={() => setEditModal(false)}
//         />
//       </div>
//       <Footer />
//     </div>
//   )
// }

import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Banner from "../Components/CourseDetailPage/Banner";
import axios from "axios";
import Swal from "sweetalert2";
import Lottie from "react-lottie"; // Make sure you have react-lottie installed

import Reviews from "../Components/CourseDetailPage/Reviews";
import StudentsSection from "../Components/CourseDetailPage/StudentsSection";
import AddMaterial from "../Components/CourseDetailPage/AddMaterial";
import EditCourseModal from "../Components/CourseDetailPage/EditCourseModal";
import { Card, Container, Spinner } from "react-bootstrap";
import CourseSection from "../Components/CourseDetailPage/CourseViewer";
import Learnyou from "../Components/CourseDetailPage/Learnyou";
import { Lock } from "lucide-react"; // Using lucide-react for a nice icon

// --- NEW: Reusable Animated Loader for the content area ---
// IMPORTANT: Replace the empty 'loadingAnimationData' object with your actual Lottie JSON import.
// Example: import myLoaderAnimation from './animations/loader.json';
const loadingAnimationData = {};

const AnimatedContentLoader = () => {
  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "40vh", // Ensures it takes up space while loading
        padding: "2rem",
      }}
    >
      {Object.keys(loadingAnimationData).length > 0 ? (
        <Lottie options={lottieOptions} height={150} width={150} />
      ) : (
        // Fallback to a standard spinner if no Lottie data is provided
        <Spinner animation="border" variant="primary" style={{ width: "4rem", height: "4rem" }} />
      )}
      <h5 className="text-muted mt-3">Loading Content...</h5>
    </div>
  );
};

// --- NEW: Redesigned prompt without a button ---
const EnrollPrompt = () => (
  <Container className="my-5">
    <Card className="text-center p-4 p-md-5 shadow-sm border-0" style={{ backgroundColor: '#fff8e1' }}>
      <Card.Body>
        <Lock size={48} className="mb-3 text-warning" />
        <h2 className="fw-bold">View the Full Course</h2>
        <p className="lead text-muted my-3">
          To access all video lessons and learning materials, please enroll in the course using the button in the banner above.
        </p>
      </Card.Body>
    </Card>
  </Container>
);

export default function CourseDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  // State variables
  const [course, setCourse] = useState({ parts: [], course_key_points: {} });
  const [materials, setMaterials] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [students, setStudents] = useState([]);
  const [isInstructor, setInstructor] = useState(false);
  const [isEnrolled, setEnrolled] = useState(false);
  
  // Modal visibility states
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setEditModal] = useState(false);

  // Loading states
  const [contentLoading, setContentLoading] = useState(true); // For the content area
  const [enrollLoading, setEnrollLoading] = useState(false); // For enroll button action

  const token = localStorage.getItem("jwttoken");
  const API_BASE_URL = "https://kaasbackend.vetrinahealthcare.com/";

  // Centralized function to fetch all course-related data
  const fetchAllCourseData = useCallback(async () => {
    setContentLoading(true); // Start content loader
    try {
      const headers = { Authorization: `Bearer ${token}` };
      
      const [courseRes, materialsRes, reviewsRes, studentsRes] = await Promise.all([
        axios.get(`${API_BASE_URL}lms/courses/${id}/`, { headers }),
        axios.get(`${API_BASE_URL}lms/courses/${id}/materials/`, { headers }),
        axios.get(`${API_BASE_URL}lms/review/${id}/`, { headers }),
        axios.get(`${API_BASE_URL}lms/courses/${id}/students`, { headers }),
      ]);

      setCourse(courseRes.data);
      setInstructor(courseRes.data.display.is_instructor);
      setEnrolled(courseRes.data.display.is_enrolled);
      setMaterials(materialsRes.data.materials || []);
      setReviews(reviewsRes.data.reviews || []);
      setStudents(studentsRes.data.students || []);

    } catch (error) {
      console.error("Error fetching course data:", error);
      Swal.fire({
        title: "Error!",
        text: "Could not load course details. Please try again later.",
        icon: "error",
      });
      navigate('/CoursePage'); 
    } finally {
      setContentLoading(false); // Stop the content loader
    }
  }, [id, token, navigate]);
  
  useEffect(() => {
    fetchAllCourseData();
  }, [fetchAllCourseData]);

  const handleEnroll = () => {
    if (isEnrolled) {
      Swal.fire("Already Enrolled", "You are already enrolled in this course.", "info");
      return;
    }
    setEnrollLoading(true);
    axios
      .post(
        `${API_BASE_URL}lms/enroll/${id}/`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        Swal.fire({
          title: "Success!",
          text: "Enrollment Successful!",
          icon: "success",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
        fetchAllCourseData(); // Re-fetch all data to update UI
      })
      .catch((error) => {
        console.error("Enrollment error:", error.response?.data?.detail || error.message);
        Swal.fire({
          title: "Enrollment Failed",
          text: error.response?.data?.detail || "You may already be enrolled.",
          icon: "warning",
        });
      })
      .finally(() => {
        setEnrollLoading(false);
      });
  };

  return (
    <div>
      <Header />
      <div
        className="px-5 pt-4"
        style={{
          backgroundImage: "linear-gradient(180.06deg, #E9F7FA 29.88%, #F8EEF5 58.49%)",
        }}
      >
        <Banner
          course={course}
          isEnrolled={isEnrolled}
          isInstructor={isInstructor}
          trailer={course.trailer}
          lessonCount={course.parts.length}
          onEnroll={handleEnroll}
          enrollLoading={enrollLoading}
        />
        <Learnyou courseKeyPoints={course.course_key_points} />

        {/* --- Main Content Area: Loader or Actual Content --- */}
        {contentLoading ? (
          <AnimatedContentLoader />
        ) : (
          <>
            {isEnrolled || isInstructor ? <CourseSection /> : <EnrollPrompt />}
            {isInstructor && <StudentsSection students={students} />}
            <Reviews reviews={reviews} />
          </>
        )}
        
        {/* Modals */}
        <AddMaterial
          course_id={id}
          show={showModal}
          handleClose={() => setShowModal(false)}
        />
        <EditCourseModal
          course_id={id}
          show={showEditModal}
          handleClose={() => setEditModal(false)}
        />
      </div>
      <Footer />
    </div>
  );
}